"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTextarea = exports.StyledCancel = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _communication = require("../../../../icons-react/communication");
var _iconsReact = require("../../../../icons-react");
var _excluded = ["placeholder"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var NoteForm = /*#__PURE__*/function (_React$PureComponent) {
  function NoteForm(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, NoteForm);
    _this = _callSuper(this, NoteForm, [props]);
    _this.state = {
      value: props.value,
      initialValue: props.value
    };
    _this.textarea = /*#__PURE__*/_react["default"].createRef();
    _this.resizeTextarea = _this.resizeTextarea.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(NoteForm, _React$PureComponent);
  return (0, _createClass2["default"])(NoteForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var initialValue = this.state.initialValue;
      this.minTextareaHeight = window.getComputedStyle(this.textarea.current).getPropertyValue('min-height');
      if (initialValue.length) {
        this.textarea.current.style.height = this.minTextareaHeight;
        this.resizeTextarea();
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref) {
      var target = _ref.target;
      this.setState({
        value: target.value
      }, this.resizeTextarea);
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var onSubmit = this.props.onSubmit;
      var value = this.state.value;
      onSubmit({
        value: value
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      var initialValue = this.state.initialValue;
      var onCancel = this.props.onCancel;
      var updatedState = {
        value: initialValue
      };
      this.setState(updatedState, onCancel);
      this.textarea.current.value = initialValue;
      this.textarea.current.style.height = this.minTextareaHeight;
      this.resizeTextarea();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(_ref2) {
      var key = _ref2.key;
      if (key === 'Backspace') {
        this.textarea.current.style.height = this.minTextareaHeight;
      }
      if (key === 'Enter') {
        this.handleSubmit();
      }
    }
  }, {
    key: "resizeTextarea",
    value: function resizeTextarea() {
      var el = this.textarea.current;
      var scrollHeight = el.scrollHeight;
      el.style.height = "".concat(scrollHeight, "px");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        value = _this$state.value,
        initialValue = _this$state.initialValue;
      var _this$props = this.props,
        placeholder = _this$props.placeholder,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledNoteForm, props, /*#__PURE__*/_react["default"].createElement(StyledTextarea, {
        autoFocus: true,
        value: value,
        ref: this.textarea,
        placeholder: placeholder,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown
      }), /*#__PURE__*/_react["default"].createElement(StyledActions, null, /*#__PURE__*/_react["default"].createElement(StyledCancel, {
        functional: true,
        onClick: this.handleCancel
      }, /*#__PURE__*/_react["default"].createElement(StyledDeleteIcon, null)), /*#__PURE__*/_react["default"].createElement(StyledButton, {
        functional: true,
        disabled: !value.length,
        onClick: this.handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(StyledArrowEnterIcon, null))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, _ref4) {
      var value = _ref3.value;
      var initialValue = _ref4.initialValue;
      if (value === initialValue) return null;
      return {
        initialValue: value,
        value: value
      };
    }
  }]);
}(_react["default"].PureComponent);
NoteForm.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func,
  onCancel: _propTypes["default"].func
};
NoteForm.defaultProps = {
  className: '',
  value: '',
  placeholder: '',
  onSubmit: Function.prototype,
  onCancel: Function.prototype
};
var StyledActions = _styledComponents["default"].div.withConfig({
  displayName: "NoteForm__StyledActions",
  componentId: "sc-nbq7s0-0"
})(["display:flex;width:14px;margin-left:10px;align-items:center;flex-direction:column;"]);
var StyledNoteForm = _styledComponents["default"].div.withConfig({
  displayName: "NoteForm__StyledNoteForm",
  componentId: "sc-nbq7s0-1"
})(["display:flex;"]);
var StyledTextarea = exports.StyledTextarea = _styledComponents["default"].textarea.withConfig({
  displayName: "NoteForm__StyledTextarea",
  componentId: "sc-nbq7s0-2"
})(["width:100%;resize:none;height:114px;font-size:14px;padding:4px 8px;font-family:'Backpack';background:none;min-height:114px;max-height:114px;border-radius:4px;border:solid 1px #f5efa8;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "NoteForm__StyledButton",
  componentId: "sc-nbq7s0-3"
})(["path{stroke:#919499;}&:hover{path{stroke:#007aff;}}", ""], function (props) {
  return props.disabled && "\n    opacity: .7;\n    pointer-events: none;\n  ";
});
var StyledArrowEnterIcon = (0, _styledComponents["default"])(_communication.ArrowEnter).withConfig({
  displayName: "NoteForm__StyledArrowEnterIcon",
  componentId: "sc-nbq7s0-4"
})(["width:14px;height:11px;"]);
var StyledCancel = exports.StyledCancel = (0, _styledComponents["default"])(StyledButton).withConfig({
  displayName: "NoteForm__StyledCancel",
  componentId: "sc-nbq7s0-5"
})(["margin-bottom:10px;"]);
var StyledDeleteIcon = (0, _styledComponents["default"])(_iconsReact.Close).withConfig({
  displayName: "NoteForm__StyledDeleteIcon",
  componentId: "sc-nbq7s0-6"
})(["width:12px;height:12px;"]);
NoteForm.StyledTextarea = StyledTextarea;
NoteForm.StyledCancel = StyledCancel;
var _default = exports["default"] = NoteForm;